import { useOrgNavigate } from 'hooks/useOrgNavigate';

import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import { TRANSLATIONS } from './constants';

type Props = {
  batchId: number;
  totalPayoutRequestsCount?: number;
};

export const ViewPayoutsButton = ({
  batchId,
  totalPayoutRequestsCount
}: Props) => {
  const navigate = useOrgNavigate();

  const handleClick = () => {
    navigate(`/batches/${batchId}/batch_payouts`);
  };

  const count = totalPayoutRequestsCount ?? 0;
  const label =
    count === 1
      ? TRANSLATIONS.VIEW_PAYOUT_SINGLE
      : TRANSLATIONS.VIEW_PAYOUT_MULTI(count);

  return (
    <div className="pt-3">
      <SecondaryButton
        onClick={handleClick}
        data-testid="batch-details-button-view-payouts"
        className="w-full"
      >
        {label}
      </SecondaryButton>
    </div>
  );
};
